import { api } from './api';

export interface DashboardKpis {
  recetas_activas: number;
  clientes_activos: number;
  pedidos_pendientes: number;
  minutas_activas: number;
  ingredientes_stock_bajo: number;
  ordenes_compra_abiertas: number;
  movimientos_ultimos_30d: number;
}

export interface ActividadRecienteItem {
  id: number;
  tipo: 'entrada' | 'salida' | 'ajuste' | 'merma';
  referencia: string;
  ingrediente: string;
  cantidad: number;
  unidad: string;
  usuario: string;
  fecha: string;
}

export interface StockBajoItem {
  id: number;
  nombre: string;
  unidad_medida: string;
  stock_actual: number;
  stock_minimo: number;
}

export interface DashboardStats {
  kpis: DashboardKpis;
  pedidos_por_estado: Record<string, number>;
  actividad_reciente: ActividadRecienteItem[];
  stock_bajo: StockBajoItem[];
  generado_en: string;
}

export const dashboardApi = {
  getStats: async (): Promise<DashboardStats> => {
    const { data } = await api.get<{ success: boolean; data: DashboardStats }>(
      '/dashboard/stats'
    );
    return data.data;
  },
};
